import { SET_CENTRIFUGO } from "constants/centrifugo";

export const setCentrifugo = (centrifugo) => async (dispatch) =>
  dispatch({
    type: SET_CENTRIFUGO,
    open,
    centrifugo,
  });
